import React, { useState } from "react";
import type { Ticket } from "../types";
import TicketDraggableCard from "./TicketDraggableCard";
import TicketQuickCreatePanel from "./TicketQuickCreatePanel";

type Props = {
    tickets: Ticket[];
    eventId: number;
    selectedTicket: Ticket | null;
    onSelectTicket: (t: Ticket) => void;
    onCreate: () => void;
    onDelete: (ticketID: number) => void;
    onBulkCreate: (tickets: Ticket[]) => Promise<void> | void;

    ticketSearch: string;
    setTicketSearch: (v: string) => void;
    showActiveOnly: boolean;
    setShowActiveOnly: (v: boolean) => void;
    hideExpired: boolean;
    setHideExpired: (v: boolean) => void;

    ignoreShiftTimeRule: boolean;
    setIgnoreShiftTimeRule: (v: boolean) => void;
};

export default function TicketsListPanel({
    tickets,
    eventId,
    selectedTicket,
    onSelectTicket,
    onCreate,
    onDelete,
    onBulkCreate,
    ticketSearch,
    setTicketSearch,
    showActiveOnly,
    setShowActiveOnly,
    hideExpired,
    setHideExpired,
    ignoreShiftTimeRule,
    setIgnoreShiftTimeRule,
}: Props) {
    const [quickOpen, setQuickOpen] = useState(false);

    return (
        <div className="form-container" style={{ height: "fit-content" }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                <h2 style={{ margin: 0 }}>Tickets</h2>

                <div style={{ display: "flex", gap: 8 }}>
                    <button
                        className="edit-btn"
                        type="button"
                        onClick={() => setQuickOpen((v) => !v)}
                        title="Åbn hurtig opret"
                    >
                        {quickOpen ? "− Hurtig opret" : "+ Hurtig opret"}
                    </button>

                    <button className="add-btnnew" onClick={onCreate}>
                        + Create
                    </button>
                </div>
            </div>

            <div
                style={{
                    marginTop: quickOpen ? 12 : 0,
                    maxHeight: quickOpen ? 1000 : 0,
                    overflow: "hidden",
                    opacity: quickOpen ? 1 : 0,
                    transition: "all 0.25s ease",
                }}
            >
                <TicketQuickCreatePanel
                    onBulkCreate={onBulkCreate}
                    eventId={eventId}
                />
            </div>

            <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                <input
                    type="text"
                    placeholder="Søg ticket..."
                    value={ticketSearch}
                    onChange={(e) => setTicketSearch(e.target.value)}
                    style={{
                        flex: 1,
                        padding: "8px 10px",
                        borderRadius: 6,
                        border: "1px solid #ccc",
                    }}
                />
            </div>

            <div className="ticket-toggles">
                <div className="toggleRow">
                    <label className="toggleSwitch">
                        <input
                            type="checkbox"
                            checked={showActiveOnly}
                            onChange={(e) => setShowActiveOnly(e.target.checked)}
                        />
                        <span className="slider" />
                    </label>
                    <span className="toggleText">Active only</span>
                </div>

                <div className="toggleRow">
                    <label className="toggleSwitch">
                        <input
                            type="checkbox"
                            checked={hideExpired}
                            onChange={(e) => setHideExpired(e.target.checked)}
                        />
                        <span className="slider" />
                    </label>
                    <span className="toggleText">Skjul udløbne</span>
                </div>

                <div className="toggleRow">
                    <label className="toggleSwitch">
                        <input
                            type="checkbox"
                            checked={ignoreShiftTimeRule}
                            onChange={(e) => setIgnoreShiftTimeRule(e.target.checked)}
                        />
                        <span className="slider" />
                    </label>
                    <span className="toggleText">Ignorer vagt-tidsregel</span>
                </div>
            </div>

            <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 10 }}>
                {tickets.map((t) => (
                    <div key={t.ticketID}>
                        <TicketDraggableCard
                            ticket={t}
                            selected={selectedTicket?.ticketID === t.ticketID}
                            onSelect={() => onSelectTicket(t)}
                            onEdit={() => onSelectTicket(t)}
                            onDelete={() => onDelete(t.ticketID!)}
                        />
                    </div>
                ))}

                {!tickets.length ? (
                    <div style={{ color: "#666", fontSize: 13 }}>
                        Ingen tickets matcher filteret.
                    </div>
                ) : null}
            </div>
        </div>
    );
}